module.exports = __webpack_public_path__ + "images/skype_icon.png";